import React from 'react';
import { Breadcrumb } from 'react-bootstrap';
import PropTypes from 'prop-types';
import BreadcrumbLink from './BreadcrumbLink';

class Breadcrumbs extends React.Component {
	render() {
		const { crumbs } = this.props;
		return (
			<Breadcrumb className="axui ux-container">
				{crumbs.map(({ path, name }) => {
					if (path) {
						return (
							<BreadcrumbLink key={name} href={path}>
								{name}
							</BreadcrumbLink>
						);
					}
					// BreadcrumbLink requires href so don't let it complain
					return (
						<li key={name} className="active">
							{name}
						</li>
					);
				})}
			</Breadcrumb>
		);
	}
}

Breadcrumbs.propTypes = {
	crumbs: PropTypes.arrayOf(
		PropTypes.shape({
			link: PropTypes.string,
			name: PropTypes.string
		})
	)
};

export default Breadcrumbs;
